import React from 'react';
interface HoneypotFieldProps {
  id: string;
  value: string;
  onChange: (value: string) => void;
}

/* Hidden from people and assistive tech; automated bots tend to fill it in. */
export function HoneypotField({
  id,
  value,
  onChange
}: HoneypotFieldProps) {
  return <div aria-hidden="true" className="absolute -left-[9999px] h-px w-px overflow-hidden" data-id="element-187" data-mp="2j9kyybptzjbw">
      <label htmlFor={id} data-id="element-188" data-mp="2jbxg4mnrlpnw">Leave this field empty</label>
      <input id={id} name="website" type="text" tabIndex={-1} autoComplete="off" value={value} onChange={e => onChange(e.target.value)} data-id="element-189" data-mp="1vkrz44638rc0" />
    </div>;
}